import React, {memo} from 'react'
import {getGroupLocationPath} from '@components/columns/column-store'
import {BoardTitle} from './board-title'
import {ColumnTitle} from './column-title'
import {TaskTitle} from './task-title'
import {ColumnProps} from './types'

export const Title = memo(({item}: ColumnProps) => {
  const {type, hub, mirror} = item

  if (type === 'board') {
    return <BoardTitle hub={hub} {...item} />
  } else if (type === 'column' && mirror) {
    const mirrorPath = getGroupLocationPath(hub)
      .map(h => h.title)
      .join(' / ')

    return <ColumnTitle hub={hub} {...item} mirrorPath={mirrorPath} />
  } else if (type === 'column') {
    return <ColumnTitle hub={hub} {...item} />
  } else {
    return <TaskTitle hub={hub} {...item} />
  }
})
